import SecureResidenceSubFrame from './SecureResidenceSubFrame';
import { panelByFrameId } from '../../utils/secureResidenceFlow';

const panel = panelByFrameId('frame-27')!;

export default function Frame27() {
  return <SecureResidenceSubFrame panel={panel} />;
}
